<app-preloader></app-preloader>
  <app-navbar-two *ngIf="!hideNavbarAndFooter"></app-navbar-two>
    <router-outlet></router-outlet>
<app-footer *ngIf="!hideNavbarAndFooter"></app-footer>